import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {AlertService, UserService} from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import {ImapUserMapping} from '@app/_components/imap-user-mapping/imap-user-mapping';
import {ImapUserMappingService} from '@app/_components/imap-user-mapping/imap-user-mapping.service';
import {first} from 'rxjs/operators';
import {InboxService} from '@app/_components/inbox';
import {ImapConfigurationService} from '@app/_components/imap-configuration/imap-configuration.service';

@Component({
    selector: 'app-imap-user-mapping',
    templateUrl: './imap-user-mapping.component.html',
    styleUrls: ['./imap-user-mapping.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ImapUserMappingComponent implements OnInit {
  selectedUser: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private imapUserMappingService: ImapUserMappingService,
    private imapConfigurationService: ImapConfigurationService,
		private alertService: AlertService,
		private userService: UserService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
    private inboxService: InboxService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.imapUserMapping = data.imapUserMapping,
			this.statuses = imapUserMappingService.statuses;

    try {
      this.imapConfigurationService.findAllWithoutPage()
        .subscribe(
          res => {
            this.mailBoxes = res.data.imapConfiguration;
            console.log(this.mailBoxes);
          },
          err => {
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
          },
          () => { });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
	}

	@Input() imapUserMapping: ImapUserMapping;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	imapUserMappingId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	userId: any;
	users: any[] = [];
	statuses: any;
  mailBoxes: any;
  updatedMailBoxes: any[] = [];

  columns: any[] = [
    { field: 'hasAccess', header: 'hasAccess', width: 'auto' },
    { field: 'name', header: 'name', width: 'auto' },
    { field: 'email', header: 'eMail', width: 'auto' },
    { field: 'host', header: 'host', width: 'auto' },
  ];

	validationMessages = {
		'imapUserMappingId': [],
		'userId': []
	};


	ngOnInit() {
		this.primengConfig.ripple = true;
		this.fetchUsers();
		this.formBuild();

		// if we were passed the whole imapUserMapping object
		if (this.imapUserMapping) {
			this.imapUserMappingId = this.imapUserMapping.imapUserMappingId;
			this.fixDates();
			this.form1.patchValue(this.imapUserMapping);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.imapUserMappingId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.imapUserMappingService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.imapUserMapping = res.data.imapUserMapping;
						this.doAdd.emit(this.imapUserMapping);
					},
					(err: any) => {
						console.log('imapUserMapping-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('imapUserMapping: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.imapUserMappingService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.imapUserMapping = res.data.imapUserMapping;
						this.doUpdate.emit(this.imapUserMapping);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.imapUserMappingService.delete(this.imapUserMapping.imapUserMappingId)
				.subscribe(
					(res: any) => {
						console.log('imapUserMapping-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.imapUserMapping);
					},
					(err: any) => {
						console.log('imapUserMapping-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			imapUserMappingId: [this.imapUserMappingId],
			userId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.imapUserMapping.imapUserMappingDate = moment(this.imapUserMapping.imapUserMappingDate).toDate();
	}

	fetchUsers() {
		if (!this.users || this.users === undefined || this.users.length < 1) {
			try {
				this.userService.findAll()
					.subscribe(
						res => {
							console.log('findAll Users: ' + JSON.stringify(res));
							this.users = res.data.users;
							return this.users;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.users);
		}
	}
	onUserSeleted(user: any) {
    this.selectedUser = user;
    this.imapUserMappingService.findAllByUserId(user.userId).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        let permissions = data.data.imapConfiguration;
        let inboxids = [];
        for ( let j = 0; j < permissions.length; j++) {
          inboxids[j] = permissions[j].imapConfigurationId;
        }
        for ( let i = 0; i < this.mailBoxes.length; i++){
          this.mailBoxes[i].hasAccess = false;
          for ( let j = 0; j < permissions.length; j++) {
            if (permissions[j].imapConfigurationId === this.mailBoxes[i].imapConfigurationId ){
              this.mailBoxes[i].hasAccess = true;
              this.mailBoxes[i].imapUserMappingId = permissions[j].imapUserMappingId;
              break;
            }
          }
        }
        this.updatedMailBoxes = this.mailBoxes;
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
	}
  onKeyInput(event)
  {
    let query = event.query;
    this.findUsersWith(query);
    return this.users;
  }

  findUsersWith(queryString: string)
  {
    this.userService.findUsersWith(queryString).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.users = [];
        this.users = data.data.userSummaryList;
        this.users.forEach(user => {
          if ( !user.lastName) { user.lastName = ''; }
          if ( !user.firstName) { user.firstName = ''; }
          user.fullName = user.lastName + ' ' + user.firstName + ' ' + user.emailAddress + ' ' + user.userId;
        });
        // console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }
  userInfo(event: any){
    this.userId = event;
  }

  changePermission(event: any, rowData: any) {
    let imapUserMapping: ImapUserMapping = new ImapUserMapping();
    imapUserMapping.userId = this.selectedUser.userId;
    imapUserMapping.imapConfigurationId = rowData.imapConfigurationId;
    if (event.checked){
      this.imapUserMappingService.add(imapUserMapping)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.onUserSeleted(this.selectedUser);
          },
          (err: any) => {
            console.log('imapUserMapping-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    }
    else{
      this.imapUserMappingService.delete(rowData.imapUserMappingId)
        .subscribe(
          (res: any) => {
            console.log('imapUserMapping-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.onUserSeleted(this.selectedUser);
          },
          (err: any) => {
            console.log('imapUserMapping-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    }
  }
}
